export default {
  metadata: {
    version: '1.0.0',
    id: 'list-block-1.0.0',
    name: 'JDSListBlock',
    description: '',
    usage: ''
  },
  hierarchy: {
    'root-container': [
      'top-slot',
      {
        'main-container': [
          'prefix-slot',
          {
            'block-container': [
              'title-jds-text',
              {
                'caption-container': [
                  {
                    'inner-caption-container': [
                      'caption-block-text-slot',
                      'caption-block-helper-slot'
                    ]
                  },
                  'caption-block-value-slot'
                ]
              },
              {
                'title-container': [
                  {
                    'inner-title-container': [
                      'title-block-text-slot',
                      'title-block-helper-slot'
                    ]
                  },
                  'title-block-value-slot'
                ]
              },
              {
                'helper-container': [
                  {
                    'inner-helper-container': [
                      'helper-block-text-slot',
                      'helper-block-helper-slot'
                    ]
                  },
                  'helper-block-value-slot'
                ]
              }
            ]
          },
          'suffix-slot'
        ]
      },
      'children-slot'
    ]
  },
  base: {
    'root-container': {
      'flex-direction': '{l_0}',
      width: '{l_1}',
      'justify-content': '{l_2}',
      'align-items': '{l_3}',
      gap: '{l_4}',
      'padding-top': '{l_5}',
      'padding-bottom': '{l_6}'
    },
    'main-container': {
      'flex-direction': '{l_7}',
      width: '{l_8}',
      gap: '{l_9}',
      'justify-content': '{l_10}',
      'align-items': '{l_11}'
    },
    'block-container': {
      'flex-direction': '{l_12}',
      flex: 1,
      gap: '{l_13}',
      'justify-content': '{l_14}',
      'align-items': '{l_15}'
    },
    'caption-container': {
      'flex-direction': '{l_16}',
      width: '{l_17}',
      'justify-content': '{l_18}',
      'align-items': '{l_19}',
      gap: '{l_20}'
    },
    'inner-caption-container': {
      'flex-direction': '{l_21}',
      'justify-content': '{l_22}',
      'align-items': '{l_23}',
      gap: '{l_24}'
    },
    'title-container': {
      'flex-direction': '{l_25}',
      width: '{l_26}',
      'justify-content': '{l_27}',
      'align-items': '{l_28}',
      gap: '{l_29}'
    },
    'inner-title-container': {
      'flex-direction': '{l_30}',
      'justify-content': '{l_31}',
      'align-items': '{l_32}',
      gap: '{l_33}'
    },
    'helper-container': {
      'flex-direction': '{l_34}',
      width: '{l_35}',
      'justify-content': '{l_36}',
      'align-items': '{l_37}',
      gap: '{l_38}'
    },
    'inner-helper-container': {
      'flex-direction': '{l_39}',
      'justify-content': '{l_40}',
      'align-items': '{l_41}',
      gap: '{l_42}'
    },
    'title-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    }
  },
  variant: {
    spacing: {
      small: {
        'main-container': {
          gap: '{l_43}'
        },
        'root-container': {
          gap: '{l_44}'
        }
      }
    },
    verticalAlignment: {
      top: {
        'main-container': {
          'align-items': '{l_45}'
        }
      }
    },
    _isTitleVisible: {
      true: {
        'caption-container': {
          hidden: true
        },
        'title-container': {
          hidden: true
        },
        'title-jds-text': {
          hidden: false
        }
      }
    }
  },
  api: {
    children: {
      'top-slot': {
        name: 'top',
        accepts: ['any'],
        max: 1
      },
      'prefix-slot': {
        name: 'prefix',
        accepts: ['jds_icon', 'jds_avatar', 'jds_image'],
        max: 1,
        doc_description:
          "It can take 'icon', 'avtar', 'image' as prefix for Listblock."
      },
      'suffix-slot': {
        name: 'suffix',
        accepts: ['jds_text', 'jds_icon', 'jds_button', 'jds_link'],
        max: 1,
        doc_description:
          "It can take 'icon', 'text', 'button', 'link' as suffix for Listblock."
      },
      'caption-block-text-slot': {
        name: 'captionBlockText',
        accepts: ['jds_text'],
        max: 1
      },
      'caption-block-helper-slot': {
        name: 'captionBlockHelper',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'caption-block-value-slot': {
        name: 'captionBlockValue',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'title-block-text-slot': {
        name: 'titleBlockText',
        accepts: ['jds_text'],
        max: 1
      },
      'title-block-helper-slot': {
        name: 'titleBlockHelper',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'title-block-value-slot': {
        name: 'titleBlockValue',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'helper-block-text-slot': {
        name: 'helperBlockText',
        accepts: ['jds_text'],
        max: 1
      },
      'helper-block-helper-slot': {
        name: 'helperBlockHelper',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'helper-block-value-slot': {
        name: 'helperBlockValue',
        accepts: ['jds_text', 'jds_badge', 'jds_tag'],
        max: 1
      },
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    config: {
      spacing: {
        values: ['medium', 'small'],
        doc_description: 'Adjusts the spacing between ListBlock contents'
      },
      verticalAlignment: {
        values: ['middle', 'top'],
        doc_description: 'Vertical alignment for Prefix and Suffix.'
      },
      _isTitleVisible: {
        values: [false, true]
      }
    },
    data: {
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      }
    },
    events: {
      'root-container': {
        onClick: 'onClick'
      },
      'prefix-slot': {
        onClick: 'onPrefixClick'
      },
      'suffix-slot': {
        onClick: 'onSuffixClick'
      }
    }
  }
};
